import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  getLeadFinancial,
  GetLeadFinancialApiResponse,
} from '@/actions/leads/getLeadFinancial';
import { ApiResponse } from '@/types/response.type';

export interface UseGetLeadFinancialReturn {
  result: ApiResponse<GetLeadFinancialApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetLeadFinancial = (
  candidateId: string
): UseGetLeadFinancialReturn => {
  const query: UseQueryResult<
    ApiResponse<GetLeadFinancialApiResponse> | undefined,
    Error
  > = useQuery({
    queryKey: ['zee-candidate-financial', candidateId],
    queryFn: () => getLeadFinancial(candidateId),
    enabled: !!candidateId,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
